module.exports = __webpack_public_path__ + "img/car-int.58d75ba5.jpeg";